module.exports = __webpack_public_path__ + "2facce4e2857b361a3c68666ff36ff90.webp";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_4.webp
// module id = ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_4.webp
// module chunks = 40